//首页
import request from '@/plugins/axios'

// 首页-查询
export function queryPageForIndexApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForIndex',
        method: 'post',
        data
    })
}
// 待审核数量
export function getWaitAuditApi(data) {
    return request({
        url: '/idx/v1.0.0/getWaitAudit',
        method: 'post',
        data
    })
}

// 待归档数量
export function getWaitArchiveApi(data) {
    return request({
        url: '/idx/v1.0.0/getWaitArchive',
        method: 'post',
        data
    })
}

// 待查款到账数量
export function getCheckedAndCreditedIntoAccountApi(data) {
    return request({
        url: '/idx/v1.0.0/getCheckedAndCreditedIntoAccount',
        method: 'post',
        data
    })
}

// 合同到期提醒数量（即将到期）
export function getNearExpirationApi(data) {
    return request({
        url: '/idx/v1.0.0/getNearExpiration',
        method: 'post',
        data
    })
}

// 已到期合同统计（数量+金额）
export function getExpiredContractsApi(data) {
    return request({
        url: '/idx/v1.0.0/getExpiredContracts',
        method: 'post',
        data
    })
}

// 已到期合同列表（分页）
export function pageForExpiredContractsApi(data) {
    return request({
        url: '/idx/v1.0.0/pageForExpiredContracts',
        method: 'post',
        data
    })
}

// 获取年度数据
export function getYearDataApi(data) {
    return request({
        url: '/idx/v1.0.0/getYearData',
        method: 'post',
        data
    })
}

// 获取月度数据
export function getMoonDataApi(data) {
    return request({
        url: '/idx/v1.0.0/getMoonData',
        method: 'post',
        data
    })
}

// 月度回款明细（yearMonth: 年月，格式 yyyy-MM，如 2026-07）
export function getMoonDetailApi(params) {
    return request({
        url: '/idx/v1.0.0/getMoonDetail',
        method: 'post',
        params
    })
}

// 消息分页
export function pageMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/pageMy',
        method: 'post',
        data: data
    })
}

// 消息列表
export function listMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/listMy',
        method: 'post',
        data: data
    })
}
// 未读数量
export function noReadCountMy(data) {
    return request({
        url: '/msgInfo/v1.0.0/noReadCountMy',
        method: 'post',
        data: data
    })
}
// 清除
export function setClear(data) {
    return request({
        url: '/msgInfo/v1.0.0/setClear',
        method: 'post',
        data: data
    })
}
// 设置已读
export function setRead(data) {
    return request({
        url: '/msgInfo/v1.0.0/setRead',
        method: 'post',
        data: data
    })
}
// 全部已读
export function setAllRead(data) {
    return request({
        url: '/msgInfo/v1.0.0/setAllRead',
        method: 'post',
        data: data
    })
}
// 全部清除
export function setAllClear(data) {
    return request({
        url: '/msgInfo/v1.0.0/setAllClear',
        method: 'post',
        data: data
    })
}

// 收款合同-分类占比（searchType: 1-按分类, 2-按负责人）
export function getReceiveClassRateApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/classRate',
        method: 'get',
        params
    })
}

// 收款合同-明细（searchType: 1-按分类, 2-按负责人；可选 personId、classNameCode 精细过滤）
export function getReceiveClassRateListApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/classRateList',
        method: 'get',
        params
    })
}

// 付款合同-分类占比（searchType: 1-按分类, 2-按负责人）
export function getMakePaymentClassRateApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/makePaymentClassRate',
        method: 'get',
        params
    })
}

// 付款合同-明细（searchType: 1-按分类, 2-按负责人；可选 personId、classNameCode 精细过滤）
export function getMakePaymentClassRateListApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/makePaymentClassRateList',
        method: 'get',
        params
    })
}

// 年度总利润-明细（year: 查询年份，如 2026）
export function getAnnualProfitApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/annualProfit',
        method: 'get',
        params
    })
}

// 合同归档统计（searchType: 1-按负责人, 2-按月份；year 必填；可选 personId、month）
export function getArchiveRateApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/archiveRate',
        method: 'get',
        params
    })
}
//发票与查款到账统计
export function getInvoiceAndCreditedIntoAccountRateApi(params) {
    return request({
        url: '/contractStatistics/v1.0.0/invoiceMonthlyStatistics',
        method: 'get',
        params
    })
}
